var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"text"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value)+" "),_c('span',[_vm._v("%")])])]),_c('div',{staticClass:"bar"},[_c('div',{staticClass:"value",style:({width: _vm.value + '%'})})])])
}
var staticRenderFns = []

export { render, staticRenderFns }